import { CommandBar, DefaultButton, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, Dialog, DialogFooter, DialogType, IButtonProps, IColumn, ICommandBarItemProps, ICommandBarStyles, IDetailsListProps, IDetailsListStyles, IDetailsRowStyles, IDialogContentProps, mergeStyleSets, PrimaryButton, Text, Toggle } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { Prompt, RouteComponentProps } from 'react-router-dom';
import { Unsubscribe } from 'redux';
import { IFeature } from '../../../shared/interfaces';
import { reduxActions, RootState } from '../../../store';
import abilityBuild from '../../../shared/CASL/appAbility';
import { RoleContext } from '../../../shared/enums';
import { checkRoles } from '../../../hoc/CheckRoles';
import CustomCommandBarButton from '../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import { myTheme } from '../../../assets/styles/my-theme';
import featuresService from '../../../services/features.service';
import { toastRef } from '../../Layout/Layout';
import { SessionState } from '../../../store/session/types';

const { palette } = myTheme;

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const classNames = mergeStyleSets({
    emptyColumn: {

    }
})

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    primarySet: {
        '& .ms-OverflowSet-item:first-of-type': {
            display: 'flex', flexFlow: 'column', justifyContent: 'center', padding: '4px'
        },
    },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const detailsListStyles: Partial<IDetailsListStyles> = {
    root: {
        overflow: 'visible',
        '& .ms-DetailsRow-cell': {
            display: 'flex',
            alignItems: 'center'
        },
        '& .ms-DetailsRow-cell:nth-child(2)': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    }
};


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {
    updateSession: (newSessionState: Partial<SessionState>) => (reduxActions.sessionActions.updateSession(newSessionState))
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface FeaturesManagerProps {

}

type Props = FeaturesManagerProps & RouteComponentProps & PropsFromRedux;

export interface FeaturesManagerState {
    commandBarItems: ICommandBarItemProps[]
    isEnabled: boolean
    columns: IColumn[]
    items: IFeature[]
    changesMade: boolean
    changesSaved: boolean
    confirmDialogIsOpen: boolean
    confirmDialogContentProps: IDialogContentProps
    confirmDialogSubmitFunction: Function
}
class FeaturesManager extends React.Component<Props, FeaturesManagerState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };

    constructor(props) {
        super(props);
        this.state = {
            commandBarItems: [
                {
                    key: 'saveChanges',
                    commandBarButtonAs: () => (
                        <CustomCommandBarButton
                            asDefaultButton={true}
                            text='Salva'
                            key='saveChanges'
                            disabled={!this.state.isEnabled}
                            iconPropsFontAwesome={{ icon: ['fa-regular', 'fa-check'] }}
                            onClick={this.saveChangesHandler}
                        />
                    )
                }
            ],
            isEnabled: false,
            columns: [
                {
                    key: 'span',
                    name: '',
                    fieldName: 'span',
                    minWidth: 16,
                    maxWidth: 16,
                    onRender: (item) => {
                        return <span></span>
                    }
                },
                {
                    key: 'name',
                    name: 'Funzionalità',
                    fieldName: 'name',
                    minWidth: 100,
                    maxWidth: 800,
                    isResizable: true,
                    isMultiline: true,
                    onRender: (item) => {
                        return <>
                            <div style={{ fontSize: 'medium' }}>{item.name}</div>
                            <div>{item.description}</div>
                        </>
                    }
                },
                {
                    key: 'toggle',
                    name: 'Attivazione',
                    minWidth: 100,
                    onRender: (item) => {
                        return <Toggle
                            label=""
                            checked={item.enabled}
                            onText="On"
                            offText="Off"
                            onChange={(ev, checked) => this.onChangeToggle(ev, item, checked)}
                            role="checkbox"></Toggle>
                    }
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,

                    className: classNames.emptyColumn,
                    headerClassName: classNames.emptyColumn,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],
            items: [],
            changesMade: false,
            changesSaved: false,
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
        }
    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('read', 'IFeature')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
        });
        if (this.props.features) {
            this.remapFeatures();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: FeaturesManagerState) {

        if (oldProps.features !== this.props.features && this.props.features) {
            this.remapFeatures();
        }

        // previene il refresh e la chiusira del tab senza salvare
        window.onbeforeunload = (event) => {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = true;
            }
            return true;
        };

    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
        window.onbeforeunload = null;
    }

    getFeatures() {
        featuresService.getFeatures()
            .then(features => {
                this.props.updateSession({ features: features });
            });
    }

    remapFeatures() {
        let featuresArray: IFeature[] = [];
        this.props.features!.map(feature => {
            if (feature.show) {
                featuresArray.push(feature);
            }
            return featuresArray;
        });
        this.setState({ items: featuresArray })
    }

    onChangeToggle = (ev: any, item: any, checked?: boolean) => {

        if (checked) {
            //controllo se la feature ha bisogno di configurazioni per l'attivazione (checked=true)
            featuresService.canActivateFeature(item.key)
                .then(response => {
                    if (response === true) {
                        this.toggleFeature(item, checked);
                    } else {
                        ev.preventDefault();
                        ev.stopPropagation();
                    }
                })
                .catch(error => {
                    ev.preventDefault();
                    ev.stopPropagation();
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non è stato possibile attivare la funzionalità',
                            life: 5000
                        });
                    }
                })
        }
        else {
            this.toggleFeature(item, checked!);
        }
    }

    // metodo per controllo Salva enabled/disabled
    isEnabledIfIsTouched = () => {
        const { items } = this.state;
        const isAnyItemTouched = items.some((item: any) => item.isTouched);

        if (isAnyItemTouched) {
            this.setState({ isEnabled: true });
        } else {
            this.setState({ isEnabled: false });
        }
    }

    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    onRenderItemRow: IDetailsListProps['onRenderRow'] = (props) => {

        const customStyles: Partial<IDetailsRowStyles> = {};
        const { item } = props!;
        if (item.isTouched) {
            customStyles.root = {
                '& .ms-DetailsRow-cell:first-child': {
                    borderRight: 'solid',
                    borderColor: `${palette.themePrimary} `
                }
            }
        }
        return <DetailsRow {...props!} styles={customStyles} />;
    }

    // Metodi per la gestione del salva:
    // Click sul salva della commandbar
    saveChangesHandler = () => {
        let featuresChanged: any[] = [...this.state.items];
        let touchedItems = featuresChanged.filter(item => item.isTouched === true);

        this.setState(
            {
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Chiudi',
                    subText: 'Vuoi salvare le modifiche?'
                },
                confirmDialogSubmitFunction: () => { this.saveChangesConfirmDialogSubmit(touchedItems) }
            }
        )
    }
    // Click su conferma del confirm dialog
    saveChangesConfirmDialogSubmit = (featuresChanged: IFeature[]) => {

        if (this.props.features && featuresChanged) {
            featuresService.updateFeatures(featuresChanged)
                .then(result => {
                    this.getFeatures();
                    toastRef.current?.show({
                        severity: 'info',
                        summary: "Operazione completata",
                        detail: `Funzionalità aggiornate correttamente`,
                        life: 5000
                    })
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: "Attenzione",
                            detail: 'Non è stato possibile aggiornare le funzionalità',
                            life: 5000
                        });
                    }
                })
        }

        this.setState({ confirmDialogIsOpen: false, isEnabled: false, changesSaved: true })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }


    private toggleFeature(item: any, checked: boolean) {

        const updatedItems = [...this.state.items];

        //trovo l'indice dell'item modificato
        const itemIndex = updatedItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
            //aggiorno l'item con il nuovo valore di enabled
            updatedItems[itemIndex] = {
                ...item,
                enabled: checked!,
                isTouched: !item.isTouched
            };
        }
        // aggiorno la lista di items
        this.setState({ items: updatedItems, changesMade: !item.isTouched, changesSaved: false }, this.isEnabledIfIsTouched);
    }

    render() {
        return (
            <React.Fragment>
                <Prompt
                    when={this.state.changesMade && !this.state.changesSaved}
                    message={"I cambiamenti non sono stati salvati. Si vuole comunque lasciare la pagina?"}
                ></Prompt>
                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>

                </Dialog>

                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={this.state.commandBarItems}
                    styles={commandBarStyles}
                />


                {this.state.items.length > 0 &&
                    <DetailsList
                        className="with-empty-column"
                        styles={detailsListStyles}
                        items={this.state.items}
                        columns={this.state.columns}
                        onRenderDetailsHeader={this.onRenderDetailsHeader}
                        onRenderRow={this.onRenderItemRow}
                        layoutMode={DetailsListLayoutMode.justified}
                        selectionMode={0}

                    />
                }
                {this.state.items.length === 0 &&

                    <Text block style={{ padding: 25 }}>Nessuna funzionalità trovata.</Text>
                }


            </React.Fragment>
        )
    }

}

export default connector(checkRoles(FeaturesManager, RoleContext.Aoo));